export const getProjects = state => state.common.selectedEntityProjects.map(({project_id, name}) => ({key: name, value: project_id}));
export const getProjectUploadValidationErrors = state => state.projects.uploadValidationErrors || [];
